var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrandColoredPapillon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65483 3.59998C7.86941 3.60183 9.03371 4.08514 9.89255 4.94397C10.7514 5.80281 11.2347 6.96711 11.2365 8.18169V12.7634H6.65483C5.43969 12.7634 4.27431 12.2807 3.41507 11.4214C2.55583 10.5622 2.07312 9.39683 2.07312 8.18169V3.59998H6.65483Z",
    fill: "#952DF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18168 20.4C8.9915 20.3987 9.7678 20.0765 10.3404 19.5039C10.9131 18.9312 11.2353 18.1549 11.2365 17.3451V14.2902H8.18168C7.37168 14.2906 6.59497 14.6125 6.02232 15.1854C5.44967 15.7583 5.12798 16.5351 5.12798 17.3451V20.4H8.18168Z",
    fill: "#952DF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3451 3.59998C16.1305 3.60183 14.9662 4.08514 14.1074 4.94397C13.2486 5.80281 12.7652 6.96711 12.7634 8.18169V12.7634H17.3451C17.9468 12.7634 18.5426 12.6449 19.0985 12.4146C19.6543 12.1844 20.1594 11.8469 20.5849 11.4214C21.0103 10.996 21.3478 10.4909 21.5781 9.93503C21.8083 9.37915 21.9268 8.78337 21.9268 8.18169V3.59998H17.3451Z",
    fill: "#952DF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8183 20.4C15.0084 20.3987 14.2321 20.0765 13.6595 19.5039C13.0869 18.9312 12.7646 18.1549 12.7634 17.3451V14.2902H15.8183C16.6283 14.2906 17.405 14.6125 17.9776 15.1854C18.5503 15.7583 18.872 16.5351 18.872 17.3451V20.4H15.8183Z",
    fill: "#952DF6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandColoredPapillon);
export default __webpack_public_path__ + "static/media/brand_colored_papillon.a08dacdab0edb758d3d34a5c75e81c7d.svg";
export { ForwardRef as ReactComponent };